<div class="flex items-center justify-center size-full bg-transparent">
  <img src="assets/images/sun.svg" alt="Loading..." class="size-14 animate-[spin_2.5s_infinite]" />
</div>
